// Older function that returns if the user is an admin console user or not (now can have multiple roles), not a main site user
export const userIsAdminConsole = (user) => {
  if (!user) return false;
  return user.userGroupId === -1;  //admin console users are in group -1
  // OLD return user.username === 'bynx.apps@bynx.com';
};

export default {};
